<template>
  <div class="connect-exchanges-header">
    <img
        src="@/assets/images/svg/exchange-connection.svg"
        alt="exchange icon"
    />
    <div class="connect-exchanges-header__items">
      <div class="connect-exchanges-header__items__line">
        <div class="connect-exchanges-header__items__line__point"
            :class="{ 'connect-exchanges-header__items__line__point--active': isFirstStep }"
        ></div>
        <div class="connect-exchanges-header__items__line__separator"></div>
        <div class="connect-exchanges-header__items__line__point"
             :class="{ 'connect-exchanges-header__items__line__point--active': isSecondStep }"
        ></div>
        <div class="connect-exchanges-header__items__line__separator"></div>
        <div class="connect-exchanges-header__items__line__point"
             :class="{ 'connect-exchanges-header__items__line__point--active': isLastStep }"
        ></div>
      </div>
      <div class="connect-exchanges-header__list">
        <ul>
          <li :class="{ 'is-active': isFirstStep }">Create an API Key</li>
          <li :class="{ 'is-active': isSecondStep }">Steps Verification</li>
          <li :class="{ 'is-active': isLastStep }">Connect API Key</li>
        </ul>
      </div>
    </div>
    <img
        src="@/assets/images/svg/close.svg"
        alt="exchange icon"
        class="connect-exchanges-header__close"
        @click="$emit('close')"
    />
  </div>
</template>

<script>
export default {
  name: "ConnectExchangesHeader",
  props: {
    currentStep: {
      type: Number,
      default: 1
    }
  },
  computed: {
    isFirstStep() {
      return this.currentStep === 1
    },
    isSecondStep() {
      return this.currentStep === 2;
    },
    isLastStep() {
      return this.currentStep === 3;
    }
  }
};
</script>

<style lang="scss" scoped>
.connect-exchanges-header {
  height: 5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 1rem 1rem 0 0;
  border-bottom: black solid 1px;
  padding: 1rem;

  &__close {
    width: 1rem;
    height: 1rem;
    cursor: pointer;
  }

  &__items__line {
    width: calc(100% - 7rem);
    margin: 0 auto;
    display: flex;
    align-items: center;

    &__point {
      width: 1rem;
      height: 0.5rem;
      border-radius: 50%;
      background: black;

      &--active {
        background: blueviolet;
      }
    }

    &__separator {
      border-bottom: 1px solid black;
      height: 1px;
      width: calc(100% - 1rem);
    }

  }

  &__list {
    margin-top: 0.25rem;

    ul {
      display: flex;
      justify-content: space-between;
      list-style: none;
      gap: 12rem;
      margin: 0;
      padding: 0;
      font-size: 12px;
      text-align: center;

      li {
        text-align: left;

        &.is-active {
          font-weight: 600;
          color: blueviolet;
        }
      }
    }
  }
}

@media (max-width:768px) {
  .connect-exchanges-header {
    height: 2.5rem;
    padding: 1rem 2rem;

    &__items {
      display: flex;
      align-items: center;

      &__line {
        width: 3.2rem;
        margin-top: 0.25rem;
        align-items: center;
        transform: rotate(90deg);
        display: flex;
        flex-direction: row;
      }

    }

    &__list ul {
        flex-direction: column;
        gap: 0.5rem;
    }
    
  }
}
</style>